import "./App.scss";
import Navbar from "./components/Navbar/Navbar";
import AppRouter from "./AppRouter";

function App () {
  return (
    <div className="App">
      <Navbar />
      <AppRouter />
    </div>
  );
}

export default App;
